

import React from 'react';
import { Container, createTheme, Grid, Typography, ThemeProvider,Button } from '@mui/material';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import MailRoundedIcon from '@mui/icons-material/MailRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LanguageIcon from '@mui/icons-material/Language';
import ScanMeHeader from "../../components/scanMe/HeaderScanMe";
import travelImage from "../../assets/images/scanMe/main_travel_image.png"


const theme = createTheme({
    typography: {
        fontFamily: 'Poppins, sans-serif',
    }
})

const GetInTouch = () => {


  return (
    <>
    <ThemeProvider theme={theme}>

    
      <ScanMeHeader />
      <Grid container>
        <Grid item xs={12} >
          <Grid container  className='d-flex align-items-center justify-content-center mt-5'>
            <Grid item xs={12} sm={4} className='align-items-center justify-content-center'>
              <Grid item className='ml-4'  sx={{ml: {xs: 6, sm: 0}}}>
                <p><span style={{ fontWeight: 'bold' }}>EA Cares</span> <span>Here for you 24/7</span></p>
              </Grid>
              <Grid item  sx={{mt: {xs: -2, sm: 0}}}>
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <Grid container direction="column" spacing={4} className='mb-3 ml-0'>
                      <Grid item sx={{mt: {xs: 2, sm: 0}}}>
                        <div className="d-flex align-items-center">
                          <SupportAgentRoundedIcon style={{ color: 'white', backgroundColor: '#fcc000', borderRadius: '20px', padding: '4px' }} />
                          <a href="tel:+912269635266" className="mb-0 ml-2" style={{ textDecoration: 'none', color: 'inherit' }}>+91 22 6963 5266</a>
                        </div>
                      </Grid>
                      <Grid item sx={{mt: {xs: -2, sm: 0}}}>
                      <div className="d-flex align-items-center">
                          <MailRoundedIcon style={{ color: 'white', backgroundColor: '#fcc000', borderRadius: '20px', padding: '4px' }} />
                          <a href="mailto:wecare@europ-assistance.in" className="mb-0 ml-2" style={{ textDecoration: 'none', color: 'inherit'}}>wecare@europ-assistance.in</a>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Grid container direction="column" spacing={4} className='mb-3 ml-0'>
                      <Grid item>
                        
                        <div className="d-flex align-items-center">
                          <LanguageIcon style={{ color: 'white', backgroundColor: '#fcc000', borderRadius: '20px', padding: '4px' }} />
                          <a href="https://www.europ-assistance.in/" target="_blank" rel="noopener noreferrer" className="mb-0 ml-2" style={{ textDecoration: 'none', color: 'inherit', fontSize: '14px' }}>europ-assistance.in</a>
                        </div>
                      </Grid>
                      <Grid item  sx={{mt: {xs: -2, sm: 0}}}>
                        <div className="d-flex align-items-center">
                          <WhatsAppIcon style={{ color: 'white', backgroundColor: '#fcc000', borderRadius: '20px', padding: '4px' }} />
                          <a href="https://wa.me/919967933888" target="_blank" rel="noopener noreferrer" className="mb-0 ml-2" style={{ textDecoration: 'none', color: 'inherit' }}>+91 99679 33888</a>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={4} className='d-flex align-items-center justify-content-center ml-2 position-relative'  sx={{mt: {xs: 2, sm: 0}}}>
              <img
                src={travelImage}
                alt='name of img'
                style={{ maxWidth: '80%', height: 'auto', borderRadius: '0px 40px 0px 40px' }}
              />
               {/* <Button
                                variant="outlined" // This is a good starting point for a button with a border
                                sx={{
                                    position: 'absolute',
                                    bottom: '24%', // Adjust as needed
                                    left: '53%',
                                    transform: 'translateX(-50%)', // Horizontally centers the button
                                    backgroundColor: 'transparent',
                                    borderRadius: '20px',      // User specified, adjust if you want more oval
                                    color: 'white',            // Text color
                                    textTransform: 'none',
                                    borderColor: 'white',      // Sets the border color to black
                                    borderWidth: '1.5px',      // Adjust thickness as needed
                                    padding: '2px 6px',       // Adjust padding for desired size
                                    fontSize: '1rem',          // Adjust font size
                                    fontWeight: 500,
                                    zIndex: 1,
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.1)', // Slight dark overlay on hover
                                        borderColor: 'black', // Keep border color black on hover
                                        color: 'white',       // Keep text color white on hover
                                    },
                                    position:'absolute'
                                    // ml: 3 is removed as it's not suitable for absolute centered positioning
                                }}
                        > Discover</Button> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      </ThemeProvider>
      
    </>
  );
}

export default GetInTouch;

